import React, { lazy, useMemo } from "react";
import { Container } from "./PaymentsHeader.style";
import { useConfig } from "../proposals/contexts/configContext";

const ConditionalPaymentsHeader: React.FC = () => {
  const { renderPaymentsHeader } = useConfig();

  if (!renderPaymentsHeader) {
    return null;
  }

  return <PaymentsHeader />;
};
/* eslint-disable react/display-name */
const PaymentsHeader = (): React.ReactElement => {
  const { origins } = useConfig();

  const PaymentsNavbarComponent = useMemo(
    () =>
      lazy(() =>
        // eslint-disable-next-line
        // @ts-ignore
        __shimport__.load(
          `${origins.www}/components/payments-navbar-component/component.mjs`
        )
      ),
    []
  );

  return (
    <Container>
      <PaymentsNavbarComponent
        GRAPHQL_ORIGIN={origins.graphql}
        AUTH_ORIGIN={origins.auth}
        WWW_ORIGIN={origins.www}
        API_ORIGIN={origins.api}
        // this is empty string and must be passed in due to auth context expecting the values to be split (graphqlUrl)
        GRAPHQL_ENDPOINT={" "}
      />
    </Container>
  );
};

export default ConditionalPaymentsHeader;
